"use client";

import type { ReactElement } from "react";

type PlayersProps = {
	lists: string[];
};

/**
 * Display the Spotify players.
 *
 * @param props The properties for the component.
 * @returns The Spotify players.
 */
export function Players(props: PlayersProps): ReactElement {
	const { lists } = props;
	return (
		<div className="hl:grid hl:gap-4 hl:lg:grid-cols-2">
			{lists.map((list) => (
				<iframe
					allow="encrypted-media;"
					className={"hl:rounded-xl"}
					height="380"
					key={list}
					src={`https://open.spotify.com/embed/playlist/${list}`}
				></iframe>
			))}
		</div>
	);
}
